<div class="reference-item uk-margin-small-bottom uk-visible-toggle" [anchorContainer]="scrollContainer"
     commentAnchor="{{fieldData.id}}" [arrayPosition]="position"
     [ngClass]="[fieldData.form.display?.cssClasses || '',
                (hideField || !fieldData.form.display?.visible) ? 'uk-hidden clear-style' : '',
                 ]">

  @if (fieldData.label.text) {
    <div class="uk-margin-bottom">
      <!--    {{ fieldData.id }}-->
      <div class="uk-flex-middle" data-uk-grid>
        <label class="uk-form-label uk-width-expand" [ngClass]="[fieldData.label.cssClasses || '']"
               style="{{fieldData.label.style}}" [for]="inputId" [innerHTML]="label">
        </label>

        @if (commentingService.hasCommenting()) {
          <div class="uk-width-auto">
            <ul class="uk-invisible-hover uk-iconnav">
              <li><a class="material-symbols-outlined" (click)="createThread()">add_comment</a></li>
            </ul>
          </div>
        }
      </div>
    </div>
  }

  @if (fieldData.form.description?.showLess) {
    @if (fieldData.form.description.text) {
      <div class="uk-form-description uk-text-small uk-margin-bottom uk-width-9-10 {{fieldData.form.description.cssClasses}}"
        style="{{fieldData.form.description.style}}">
        <read-more-text [maxHeight]="46" [text]="fieldData.form.description.text"></read-more-text>
      </div>
    }
  } @else {
    @if (fieldData.form.description?.text) {
      <div style="{{fieldData.form.description.style}}"
        class="uk-form-description uk-text-small uk-margin-bottom uk-width-9-10 {{fieldData.form.description.cssClasses}}"
        [innerHTML]="fieldData.form.description.text | safeUrl: 'html'">
      </div>
    }
  }
  <!-- Don't show content for paused and external fields -->
  @if (fieldData.kind !== 'paused' && fieldData.kind !== 'external') {
    <ng-content></ng-content>
  }

  @if (fieldData.form.suggestion.text) {
    <div class="uk-margin-top">
      <div class="uk-suggestion uk-width-9-10 {{fieldData.form.suggestion.cssClasses}}"
           style="{{fieldData.form.suggestion.style}}" [innerHTML]="fieldData.form.suggestion.text">
      </div>
    </div>
  }

  @if (fieldData.typeInfo.multiplicity && fieldData.typeInfo.type !== 'select') {
<!--    <div class="uk-suggestion uk-width-9-10 {{fieldData.form.suggestion.cssClasses}}" -->
<!--         style="{{fieldData.form.suggestion.style}}" [innerHTML]="fieldData.form.suggestion.text">-->
<!--    </div>-->
    @if (!readonly) {
      <div class="uk-width-9-10 uk-text-center uk-margin-top">
        <a class="add-new-element uk-flex uk-flex-middle uk-flex-center" (click)="push()">
          <span class="material-icons">add</span>Add &nbsp;<span [innerHTML]="fieldData.label.text"></span>
        </a>
      </div>
    }
  }

</div>
